import { ErrorComponentProps } from '@ferreri/minato-error-handler-react';
import {
  HelpIllustration,
  ModalFullScreen,
  useOriginUrl,
} from '@angeplus/prever-component-lib';

export const CouponNotFoundError = ({
  error,
  hideError,
}: ErrorComponentProps) => {
  const baseUrl = useOriginUrl();
  const planHref = `${baseUrl}/plan`;

  const handleClick = () => {
    document.location.assign(planHref);
    hideError();
  };

  return (
    <ModalFullScreen
      title="Cupom não encontrado"
      description="Cupom informado não localizado ou não existente."
      illustration={<HelpIllustration />}
      labelButtonPrimary="Prosseguir sem cupom"
      onClickButtonPrimary={handleClick}
      error={error}
    />
  );
};
